import React from "react";
import AdminShell from "../AdminShell";

const SettingsPlaceholder = ({ title, description, icon }) => {
  return (
    <AdminShell pageTitle={title}>
      <div style={{ maxWidth: 700 }}>
        <div style={{ marginBottom: 24 }}>
          <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: "#111827" }}>{title}</h2>
          <p style={{ margin: "4px 0 0", color: "#6b7280", fontSize: 13 }}>{description}</p>
        </div>
        <div style={{
          background: "#fff", borderRadius: 12, border: "1px solid #e5e7eb",
          padding: "60px 40px", textAlign: "center",
        }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>{icon || "⚙️"}</div>
          <h3 style={{ margin: 0, fontSize: 16, fontWeight: 600, color: "#374151" }}>{title}</h3>
          <p style={{ margin: "8px 0 0", color: "#9ca3af", fontSize: 13 }}>
            This section is under development. Configuration options will be available here soon.
          </p>
        </div>
      </div>
    </AdminShell>
  );
};

export default SettingsPlaceholder;
